import type { JSX } from 'react'
import type { IAvatarProps } from 'atoms/Avatar'
import type { IconNames } from 'atoms/Icon'
import type { IDropdownProps } from '../Dropdown'

import { Dropdown } from '../Dropdown'
import { DropdownRowGaps } from '../Dropdown.h'
import { DropdownHeaderNavBar } from '../DropdownHeader/Templates'
import { DropdownItemsGroupSettings } from '../DropdownItemsGroup/Templates'

export interface IDropdownNavBarProps extends IDropdownProps {
  title?: IAvatarProps['title']
  icon?: IconNames
}

export const DropdownNavBar = ({
  children,
  title = '',
  icon,
  isOpenedOnHover = true,
  rowGap = DropdownRowGaps.SIZE_20,
  ...rest
}: IDropdownNavBarProps): JSX.Element => (
  <Dropdown isOpenedOnHover={isOpenedOnHover} rowGap={rowGap} {...rest}>
    <DropdownHeaderNavBar icon={icon} title={title} />
    <DropdownItemsGroupSettings>{children}</DropdownItemsGroupSettings>
  </Dropdown>
)
